export default {
  getterMenuContext   : content => content.context,
  getterMenuTopics    : content => content.menuTopics,
  getterSelectedTopic : content => content.selectedTopic,
  getterViewedTopicId : content => content.viewedTopicId,
  getterUserContext   : content => content.userContext
};
